'use strict'

import simpleCache from 'root-core/cache/simpleCache.js'
import RoomPermutations from './roomPermutations.js'

export default class CachedRoomPermutations extends RoomPermutations {
  constructor (accommodation, priceEngine, config) {
    super(accommodation, priceEngine, config)
    this.cache = simpleCache()
  }

  bestRoomAllocations ({adults, children, teenagers}) {
    return this.cache.cacheBy(`${adults}:${children}:${teenagers}`, () => {
      return super.bestRoomAllocations({adults, children, teenagers})
    })
  }
}
